const BreakPoints = {
    xs: 320,
    sm: 600,
    md: 800,
    lg: 1100,
    xl: 1920,
};

export default BreakPoints;
